import classNames from 'classnames';
import React from 'react';
import { BreakLine } from '../../UI/BreakLine/BreakLine';
import { closedMessageMessages } from './i18n';
import { useIntl } from 'react-intl';
import { useBlockMessageClassNames } from 'src/hooks/core/messages.hooks';
import type { IOptionalMessageProps } from '../../UI/Message/Message';

export const ClosedMessage = React.forwardRef<
	HTMLDivElement,
	{ className?: string } & IOptionalMessageProps
>(function ClosedMessage({ className: classNameProp, ...props }, ref) {
	const intl = useIntl();
	const content = intl.formatMessage(closedMessageMessages.content);
	const messageClassName = useBlockMessageClassNames();

	return (
		<BreakLine
			className={classNames(
				classNameProp,
				messageClassName,
				'message--closed',
				'breakline--primary',
			)}
			ref={ref}
			{...props}
		>
			<div dangerouslySetInnerHTML={{ __html: content }} />
		</BreakLine>
	);
});
